module.exports = __webpack_public_path__ + "img/camera_active.c090fd3a.svg";